import { useTranslation } from "react-i18next";

import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Typography,
  notification,
} from "antd";
import { DashboardWrapper } from "../components/DashboardWrapper/DashboardWrapper.styles";
import { sendMessageToAdmin } from "../utils/api-lists/contact.api";

import { DownloadOutlined, MailOutlined } from "@ant-design/icons";

const inputStyle = {
  padding: "6px",
  border: "none",
  borderRadius: "5px",
  background: "rgba(72, 71, 78)",
  color: "white",
  outline: "none",
};

const { Title, Paragraph, Text } = Typography;

const HelpPage = () => {
  const { t } = useTranslation("common");
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      await sendMessageToAdmin(values.name, values.email, values.message);
      notification.success({
        message: t("email_sent_success"),
        description: t("email_sent_success_description"),
        placement: "top",
        duration: 3,
      });
    } catch (err) {
      console.log("Error:", err);
      notification.error({
        message: t("email_send_error"),
        description: t("email_send_error_description"),
        placement: "top",
        duration: 3,
      });
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <DashboardWrapper>
        <Row
          gutter={[16, 16]}
          style={{ borderRadius: 12, background: "rgba(88, 80, 109, 0.30)" }}
        >
          <Col lg={12}>
            <Card
              style={{
                background: "transparent",
                boxShadow: "none",
                border: "none",
              }}
            >
              <Title level={4}>{t("about_title")}</Title>
              <Paragraph>
                {t("about_text1")}
                <br />
                <br />
                {t("about_text2")}
              </Paragraph>
              <a
                href="https://glacies-storage.fra1.cdn.digitaloceanspaces.com/glacies-manuals/Glacies_Instructions.pdf"
                target="_blank"
                download="Glacies_Instructions.pdf"
              >
                <Button type="primary" icon={<DownloadOutlined />}>
                  {t("download_manual")}
                </Button>
              </a>
            </Card>
          </Col>

          <Col lg={12}>
            <Card
              style={{
                background: "transparent",
                boxShadow: "none",
                border: "none",
              }}
            >
              <Title level={4}>{t("how_glacies_title")}</Title>
              <Paragraph>
                {t("how_glacies_text1")}
                <br />
                <br />
                {t("how_glacies_text2")}
              </Paragraph>
            </Card>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: 36 }}>
          <Col lg={8} md={24} sm={24} xs={24} style={{ paddingLeft: 0 }}>
            <Card
              style={{
                borderRadius: 12,
                background: "rgba(88, 80, 109, 0.30)",
              }}
            >
              <Title level={5}>{t("contact_info")}</Title>
              <Paragraph style={{ marginBottom: 12 }}>
                <Text style={{ display: "block", marginBottom: 4 }}>
                  <MailOutlined style={{ marginRight: 8, color: "#fff" }} />
                  {t("email")}
                </Text>

                <Text style={{ marginLeft: 20 }}>support@glacies.bio</Text>
              </Paragraph>
              <Paragraph style={{ marginBottom: 12 }}>
                <Text style={{ display: "block", marginBottom: 4 }}>
                  <MailOutlined style={{ marginRight: 8, color: "#fff" }} />
                  {t("phone")}
                </Text>

                <Text style={{ marginLeft: 20 }}>+352 661 819 918</Text>
              </Paragraph>
            </Card>
          </Col>

          <Col lg={16} md={24} sm={24} xs={24} style={{ paddingRight: 0 }}>
            <Card
              style={{
                borderRadius: 12,
                background: "rgba(88, 80, 109, 0.30)",
              }}
            >
              <Title level={5}>{t("send_message")}</Title>
              <Form
                form={form}
                layout="vertical"
                initialValues={{ remember: false }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label={t("name")}
                      name="name"
                      rules={[{ required: true, message: t("name_required") }]}
                    >
                      <Input
                        placeholder={t("name_placeholder")}
                        style={inputStyle}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label={t("email")}
                      name="email"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: t("valid_email"),
                        },
                      ]}
                      validateTrigger="onBlur"
                    >
                      <Input
                        placeholder={t("email_placeholder")}
                        style={inputStyle}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item label={t("subject")} name="subject">
                  <Input style={inputStyle} />
                </Form.Item>

                <Form.Item
                  label={t("message")}
                  name="message"
                  rules={[{ required: true, message: t("message") }]}
                >
                  <Input.TextArea
                    rows={4}
                    placeholder={t("message_placeholder")}
                    style={inputStyle}
                  />
                </Form.Item>

                <Button type="primary" htmlType="submit">
                  {t("send_message_btn")}
                </Button>
              </Form>
            </Card>
          </Col>
        </Row>
      </DashboardWrapper>
    </>
  );
};

export default HelpPage;
